export default function AppIconView(props: { url: string; description?: string }): JSX.Element {
    return (
        <img
            alt={props.description ?? 'App icon'}
            height={'100%'}
            src={props.url}
            style={{ borderRadius: '1vmin' }}
        />
    );
}
